import { StoreType } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { shouldUsePaidQuickCheckout } from 'utils/quickCheckoutUtils';
import { useFeatureFlagForConsumer } from 'featureFlags/useConsumerFeatureFlag';
import { useSelector } from 'react-redux';

export interface Priceable {
  ticketPriceInformation?: core.ITicketPriceInformation | null;
  ticketCount: number;
  totalPrice: number;
  subtotal: number;
  discount: core.IDiscount[];
}

/**
 * Use this in lieiu of the private methods in {@link CompletePurchase} and {@link AcceptTermsForm} when they are migrated to function components for finding the same thing.
 */
export const usePaidQuickCheckout = (price: Priceable | null): Boolean => {
  const {
    app: { jwtToken },
  } = useSelector((state: StoreType) => ({
    app: state.app,
  }));
  const isPaidQuickCheckoutEnabled = useFeatureFlagForConsumer('PAID_QUICK_CHECKOUT');
  if (price === null) {
    return false;
  }
  return shouldUsePaidQuickCheckout(price, jwtToken, isPaidQuickCheckoutEnabled);
};
